import type { ApiClient } from '../client';
import { mapPoolItemEmbed, type IframePoolOrderItem, type RawPoolItemEmbed } from './poolOrders';

// Free, no-registration "try a demo rip" — a stateless read-only sample of
// a real, high-value card from the pack's own pool. No session token, no
// purchase, no request/callback log on the backend. Identifies the
// operator by `embedKey` alone (see `useSession().embedKey` — populated
// only when the launch URL carries `?embed_key=`; see modules/demo for the
// gating this implies).
//
// Failure paths throw ApiError; `.code` carries NOT_FOUND (pack/operator
// unknown or demo not enabled — deliberately uniform, don't branch UI copy
// on the distinction), DEMO_POOL_EMPTY (pack has nothing pullable right
// now), or a 429 (rate limited) with no code.

interface RawDemoPullResponse {
  demo?: boolean;
  pool_item?: RawPoolItemEmbed;
}

export async function pullDemoCard(
  client: ApiClient,
  poolOfferId: number | string,
  embedKey: string,
): Promise<IframePoolOrderItem> {
  const qs = new URLSearchParams({ embed_key: embedKey });
  const raw = await client.request<RawDemoPullResponse>(
    `/loot_machine/api/game_platform/iframe/v1/demo/pool_offers/${encodeURIComponent(String(poolOfferId))}/pull?${qs.toString()}`,
    { method: 'POST', anonymous: true },
  );
  // A 200 without the item means the contract moved; an empty card rendered
  // as a "win" would be worse than a visible failure.
  if (!raw?.pool_item) throw new Error('Demo pull returned no card.');
  return mapPoolItemEmbed(raw.pool_item);
}
